// hnb-frontend/src/features/provider-owner/layout/ProviderSidebar.tsx

import React from 'react';
import { NavLink } from 'react-router-dom';

const items = [
  { label: 'Dashboard', to: '/provider/dashboard' },
  { label: 'Profile', to: '/provider/dashboard/profile' },
  { label: 'Verification', to: '/provider/dashboard/verification' },
  { label: 'Stylists', to: '/provider/dashboard/stylists' },
  { label: 'Services', to: '/provider/dashboard/services' },
  { label: 'Calendar', to: '/provider/dashboard/calendar' },
  { label: 'Bookings', to: '/provider/dashboard/bookings' },
  { label: 'Finance', to: '/provider/dashboard/finance' },
  { label: 'Payment policies', to: '/provider/dashboard/finance/policies' },
  { label: 'Portfolio', to: '/provider/dashboard/portfolio' },
  { label: 'Reviews', to: '/provider/dashboard/reviews' },
  { label: 'Subscription', to: '/provider/dashboard/subscription' },
];

const sectionLabelStyle: React.CSSProperties = {
  margin: 0,
  opacity: 0.72,
  fontSize: 12,
  fontWeight: 600,
  letterSpacing: '0.06em',
  textTransform: 'uppercase',
};

const ProviderSidebar: React.FC = () => {
  return (
    <aside
      style={{
        height: '100%',
        background:
          'linear-gradient(180deg, #0f172a 0%, #111827 52%, #172033 100%)',
        color: '#fff',
        padding: '1.5rem 1rem',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div style={{ marginBottom: '1.5rem' }}>
        <p style={sectionLabelStyle}>HnB workspace</p>
        <h2
          style={{
            margin: '0.35rem 0 0',
            fontSize: 20,
            lineHeight: 1.2,
            fontWeight: 800,
          }}
        >
          Provider owner
        </h2>
        <p
          style={{
            margin: '0.55rem 0 0',
            color: 'rgba(255,255,255,0.72)',
            fontSize: 14,
            lineHeight: 1.5,
          }}
        >
          Manage services, bookings, staff, portfolio, and business operations.
        </p>
      </div>

      <nav aria-label="Provider dashboard navigation">
        <ul
          style={{
            listStyle: 'none',
            padding: 0,
            margin: 0,
            display: 'grid',
            gap: '0.35rem',
          }}
        >
          {items.map((item) => (
            <li key={item.to}>
              <NavLink
                to={item.to}
                end={item.to === '/provider/dashboard'}
                style={({ isActive }) => ({
                  display: 'block',
                  padding: '0.8rem 0.9rem',
                  borderRadius: 14,
                  color: '#fff',
                  textDecoration: 'none',
                  background: isActive
                    ? 'rgba(255,255,255,0.14)'
                    : 'transparent',
                  border: isActive
                    ? '1px solid rgba(255,255,255,0.18)'
                    : '1px solid transparent',
                  fontWeight: isActive ? 700 : 500,
                  boxShadow: isActive
                    ? '0 8px 18px rgba(15, 23, 42, 0.18)'
                    : 'none',
                  transition:
                    'background 160ms ease, border-color 160ms ease, box-shadow 160ms ease',
                })}
              >
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      <div
        style={{
          marginTop: 'auto',
          paddingTop: '1.25rem',
        }}
      >
        <div
          style={{
            borderRadius: 16,
            background: 'rgba(255,255,255,0.08)',
            border: '1px solid rgba(255,255,255,0.1)',
            padding: '0.95rem',
          }}
        >
          <p
            style={{
              margin: 0,
              fontSize: 13,
              fontWeight: 700,
              color: '#ffffff',
            }}
          >
            Go-live depends on setup
          </p>
          <p
            style={{
              margin: '0.45rem 0 0',
              fontSize: 13,
              lineHeight: 1.55,
              color: 'rgba(255,255,255,0.72)',
            }}
          >
            Verification, services, availability, and portfolio should remain in
            sync with backend onboarding status.
          </p>
        </div>
      </div>
    </aside>
  );
};

export default ProviderSidebar;